import React from 'react';

class PaymentInfo extends React.Component {
  constructor(props) {
    super(props);
    ['handleChange'].forEach((i) => {
      this[i] = this[i].bind(this);
    });
  }
  handleChange(e) {
    this.props.handleChange('CHANGE_PAYMENT_METHOD', e.target.value);
  }
  render() {
    let credit_card_details = <div className="credit-card-details">
      <div className="control-group">
        <label>Credit Card Name <span>*</span></label>
        <div className="controls">
          <input type="text" id="card-name" className="form-control card-details-field" data-stripe="name" name={this.props.payment_required ? undefined : 'credit_card_name'} required={this.props.payment_required ? 'required' : undefined} />
        </div>
        <span className="error-target"></span>
      </div>
      <div className="control-group">
        <label>Credit Card Number <span>*</span></label>
        <div className="controls">
          <input type="text" id="card-number" className="form-control card-details-field" data-stripe="number" name={this.props.payment_required ? undefined : 'credit_card_number'} required={this.props.payment_required ? 'required' : undefined} />
        </div>
        <span className="error-target"></span>
      </div>
      <div className="control-group">
        <label>CVC <span>*</span></label>
        <div className="controls">
          <input type="text" id="card-cvc" className="form-control card-details-field" data-stripe="cvc" />
        </div>
        <span className="error-target"></span>
      </div>
      <div className="control-group">
        <label>Expiration (MM/YYYY) <span>*</span></label>
        <div className="controls">
          <input type="text" id="card-exp-month" className="form-control card-details-field" placeholder="MM" data-stripe="exp-month" maxLength="2" size="2" name={this.props.payment_required ? undefined : 'credit_card_expiry_month'} required={this.props.payment_required ? 'required' : undefined} />
          <span className="input-group-addon">/</span>
          <input type="text" id="card-exp-year" className="form-control card-details-field" placeholder="YYYY" data-stripe="exp-year" maxLength="4" size="4" name={this.props.payment_required ? undefined : 'credit_card_expiry_year'} required={this.props.payment_required ? 'required' : undefined} />
        </div>
        <span className="error-target"></span>
      </div>
      <p><i>Accepted credit cards: VISA, MasterCard and AMEX</i></p>
    </div>;

    return <div className="payment-info">
      <input type="hidden" name="stripe_token" value={this.props.stripe_token} />
      <div className="control-group">
        <label>
          <b>Subtotal:</b> ${this.props.subtotal}
        </label>
      </div>
      <div className="control-group">
        <label>
          <b>Tax (13%):</b> ${this.props.tax}
        </label>
      </div>
      <div className="control-group">
        <label>
          <b>Total:</b> ${this.props.total}
        </label>
      </div>
      {this.props.total <= 0 ? undefined : <div className="control-group">
        <label>Payment Method <span>*</span></label>
        <div className="controls">
          <label>
            <input type="radio" name="payment_method" value='Cheque' onChange={this.handleChange} required /> Cheque
          </label>
          <label>
            <input type="radio" name="payment_method" value='credit_card' onChange={this.handleChange} required /> Credit Card
          </label>
          <span className="error-target"></span>
        </div>
        <span className="error-target"></span>
      </div> }
      {this.props.payment_method != 'Cheque' && this.props.total > 0 ? credit_card_details : undefined}
      <div className="control-group">
        <label className="red payment-errors">{this.props.payment_errors}</label>
      </div>
    </div>;
  }
}

// fees
class FeeOption extends React.Component {
  constructor(props) {
    super(props);
    ['handleChange'].forEach((i) => {
      this[i] = this[i].bind(this);
    });
  }
  handleChange() {
    this.props.handleChange('CHANGE_FEE', this.props.fee);
  }
  render() {
    let fee = this.props.fee;
    let [subtotal, tax, total] = this.props.eb ? [fee.eb_subtotal, fee.eb_tax, fee.eb_total] : [fee.subtotal, fee.tax, fee.total];
    let display_admin = this.props.display_admin;
    return <div className="control-group">
      <label>
        <input type="radio" name="fee" value={fee.id} required onChange={this.handleChange} defaultChecked={fee.checked} /> {fee.label} ({subtotal} + {tax} = {total})
        <span className="error-target"></span>
      </label>
    </div>;
  }
}

class FeeOptionList extends React.Component {
  render() {
    let fee_nodes = this.props.fees.map((fee) => {
      return <FeeOption key={fee.id} fee={fee} handleChange={this.props.handleChange} eb={this.props.eb} />;
    });
    return <div className="fee-option-list">{fee_nodes}</div>;
  }
}

// addons
class AddonOption extends React.Component {
  constructor(props) {
    super(props);
    ['handleChange'].forEach((i) => {
      this[i] = this[i].bind(this);
    });
  }
  handleChange(e) {
    let change_type = e.target.checked ? 'ADD_ADDON' : 'REMOVE_ADDON';
    this.props.handleChange(change_type, this.props.addon);
  }
  render() {
    let addon = this.props.addon;
    let [subtotal, tax, total] = this.props.eb ? [addon.eb_subtotal, addon.eb_tax, addon.eb_total] : [addon.subtotal, addon.tax, addon.total];
    let display_admin = this.props.display_admin;
    return <div className="control-group checkbox-group">
      <label>
        <input type="checkbox" name="addons[]" value={addon.id} onChange={this.handleChange} defaultChecked={addon.checked} /> {addon.label} ({subtotal} + {tax} = {total})
        <span className="error-target"></span>
      </label>
    </div>;
  }
}

class AddonOptionList extends React.Component {
  render() {
    let addon_nodes = this.props.addons.map((addon) => {
      return <AddonOption key={addon.id} addon={addon} handleChange={this.props.handleChange} eb={this.props.eb} />;
    });
    return <div className="addon-option-list">{addon_nodes}</div>;
  }
}

// fields
class TextField extends React.Component {
  render() {
    let type = this.props.name == 'email' ? 'email' : 'text';
    return <div className="control-group">
    <label>{this.props.label} <span>{this.props.required == 1 ? '*' : undefined}</span></label>
    <div className="controls">
      <input type={type} name={'fields['+this.props.name+']'} required={this.props.required == 1 ? 'required' : undefined} defaultValue={this.props.default_value} />
    </div>
    <span className="error-target"></span>
  </div>
  }
}

class Dropdown extends React.Component {
  render() {
    let select_nodes = this.props.response_options.map((i) => {
      return <option value={i.name}>{i.label}</option>;
    })
    select_nodes.unshift(<option value="">Please make a selection...</option>);
    return <div className="control-group">
    <label>{this.props.label} <span>{this.props.required == 1 ? '*' : undefined}</span></label>
    <div className="controls">
      <select name={'fields['+this.props.name+']'} required={this.props.required == 1 ? 'required' : undefined} defaultValue={this.props.default_value}>
        {select_nodes}
      </select>
    </div>
    <span className="error-target"></span>
  </div>
  }
}

class Radio extends React.Component {
  render() {
    let radio_nodes = this.props.response_options.map((i) => {
      return <label><input type="radio" name={'fields['+this.props.name+']'} value={i.name} defaultChecked={this.props.default_value==i.name?true:false} required={this.props.required == 1 ? 'required' : undefined} /> {i.label}</label>;
    })
    return <div className="control-group">
    <label>{this.props.label} <span>{this.props.required == 1 ? '*' : undefined}</span></label>
    <div className="controls">
      {radio_nodes}
    </div>
    <span className="error-target"></span>
  </div>
  }
}

class Checkbox extends React.Component {
  render() {
    return <div className="control-group">
    <div className="controls">
      <label><input type="checkbox" name={'fields['+this.props.name+']'} value="1" required={this.props.required == 1 ? 'required' : undefined} defaultChecked={this.props.default_value==1?true:false} /></label>
    </div>
    <label>{this.props.label} <span>{this.props.required == 1 ? '*' : undefined}</span></label>
    <span className="error-target"></span>
  </div>
  }
}

class FieldList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fields: this.props.fields };
  }

  render() {
    let field_nodes = this.props.fields.map((f) => {
      let props = {key: f.id, name: f.name, label: f.label, required: f.required, response_options: f.response_options, default_value: f.value};
      switch (f.field_type) {
        case 'text':
          return <TextField {...props} />
        case 'dropdown':
          return <Dropdown {...props} />
        case 'radio':
          return <Radio {...props} />
        case 'checkbox':
          return <Checkbox {...props} />
      }
    });
    return <div className="field-list">{field_nodes}</div>;
  }
}

export { FeeOptionList, AddonOptionList, FieldList, PaymentInfo };


/** WEBPACK FOOTER **
 ** ./src/components/form.js
 **/